import * as React from "react";
import { Tooltip } from "antd";

const getTitle = record => {
  return (
    <div>
      <div>
        <span>国内手机号：</span>
        <span>{record.phone || "-"}</span>
      </div>
      <div>
        <span>国外手机号：</span>
        <span>{record.foreignPhone || "-"}</span>
      </div>
      <div>
        <span>邮箱地址：</span>
        <span>{record.email || "-"}</span>
      </div>
    </div>
  );
};

const showForeignPhone = phone => {
  if (phone) {
    return <div>{phone}</div>;
  } else {
    return [];
  }
};

// 联系人
export default containerBody => {
  const getContainer = () => {
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };
  return {
    render: (text, record) => {
      return (
        <React.Fragment>
          <span style={{ marginRight: 4 }}>{text || "-"}</span>
          <Tooltip
            placement="top"
            title={getTitle(record)}
            overlayClassName="contact-tooltip"
            getPopupContainer={getContainer}
          >
            <i
              className="action-user action-lianxiren"
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
          {showForeignPhone(record.foreignPhone)}
        </React.Fragment>
      );
    },
    onCell: record => {
      return {
        style: {
          padding: "8px"
        },
        className: "td-text-algn-left"
      };
    }
  };
};
